
import border from '../static/images/border.svg';

import '../App.css';

const Intro = (props) => {

  return (
    <div className="card intro">
      <h3 className="card-title">园区简介</h3>
      <div className="card-body desc">
        <img src={border} className='border' alt='' />
        <p>{props.desc}</p>
      </div>
    </div>
  );
}

export default Intro;
